import ApiService from '@/services/ApiService';

const apiService = new ApiService();

const getBySessionId = async function(sessionId, notcomplete = false) {
    let slug = `session/${sessionId}/${notcomplete ? 'notcomplete' : ''}`;
    return apiService.get('recording', slug);
}

const forceTranscode = async function(recording) {
    return apiService.post('recording/transcode', recording);
}

const generateLink = async function(recording) {
    return apiService.post('recording/generateLink', recording);
}

export default {
    getBySessionId,
    forceTranscode,
    generateLink
}